export type CheckoutCancellation =
  | {
      kind: 'payment';
      transactionId: string | null;
      legacySessionId: string | null;
    }
  | {
      kind: 'subscription';
      transactionId: null;
      legacySessionId: null;
    };

export const checkoutCancellationFromSearch = (
  search: string
): CheckoutCancellation | null => {
  const params = new URLSearchParams(search);

  // A subscription return must never be interpreted as a token-purchase
  // cancellation, even if an unexpected mixed query string is supplied.
  if (params.get('subscription') === 'cancelled') {
    return {
      kind: 'subscription',
      transactionId: null,
      legacySessionId: null
    };
  }

  if (params.get('payment') !== 'cancelled') return null;
  return {
    kind: 'payment',
    transactionId: params.get('transaction_id'),
    legacySessionId: params.get('session_id')
  };
};
